import React from "react";

const HlpJoinOrCreate = () => {
  return (
    <>
      <h1> Join or Create an Effice? </h1>
      If you have an invite link enter it here.
    </>
  );
};

export default HlpJoinOrCreate;
